import { render, staticRenderFns } from "./GiveFeedback.vue?vue&type=template&id=566a424a"
import script from "./GiveFeedback.vue?vue&type=script&lang=js"
export * from "./GiveFeedback.vue?vue&type=script&lang=js"
import style0 from "./GiveFeedback.vue?vue&type=style&index=0&id=566a424a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports